import { render, staticRenderFns } from "./TeletypeChat.vue?vue&type=template&id=a3bf6fbe&scoped=true"
import script from "./TeletypeChat.vue?vue&type=script&lang=js"
export * from "./TeletypeChat.vue?vue&type=script&lang=js"
import style0 from "./TeletypeChat.vue?vue&type=style&index=0&id=a3bf6fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bf6fbe",
  null
  
)

export default component.exports